import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const getSims = async (currentPage, itemsPerPage, filters = {}) => {
    try {
        const response = await axios.get(`${apiUrl}/simcards/all`, {
            params: {
                page: currentPage,
                limit: itemsPerPage,
                ...filters,
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error al obtener los cultivos: ', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const getSim = async (simId) => {
    try {
        const response = await axios.get(`${apiUrl}/simcards/${simId}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error(`Error al obtener la sim id ${simId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const addSim = async (body) => {
    try {
        const response = await axios.post(`${apiUrl}/simcards/create`, body, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error al crear la sim: ", error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}

export const editSim = async (simId, body) => {
    try {
        const response = await axios.put(`${apiUrl}/simcards/${simId}`, body, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error(`Error al actualizar la sim id ${simId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}

export const deleteSim = async (simId) => {
    try {
        const response = await axios.delete(`${apiUrl}/simcards/${simId}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error(`Error al eliminar la sim id ${simId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}

export const getSimByIccid = async (iccid) => {
    try {
        const response = await axios.get(`${apiUrl}/simcards/all?page=1&limit=3&iccid=${iccid}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error(`Error al obtener la sim id ${iccid}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};